export function each(o, cb, s) {
  let n
  if (!o) {
    return 0
  }
  s = !s ? o : s
  if (Array.isArray(o)) {
    // Indexed arrays, needed for Safari
    for (n = 0; n < o.length; n++) {
      if (cb.call(s, o[n], n, o) === false) {
        return 0
      }
    }
  }
  else {
    // Hashtables
    for (n in o) {
      if (Object.hasOwn(o, n)) {
        if (cb.call(s, o[n], n, o) === false) {
          return 0
        }
      }
    }
  }
  return 1
}
